import { showToast } from "./toast-config";

const successToast = (message = "Success", options) =>
  showToast("success", message, "Success", options);

export default successToast;
